module.exports = {"id":"dp5_4l1q4","text":"Identifying Digital Competence Needs","instructions":"Seeking help from others can support improving digital skills.","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"5.4","questionType":"PickOne","random":false,"options":[{"id":"dp5_4l1q4-a1","text":"True","score":1.8},{"id":"dp5_4l1q4-a2","text":"Not sure","score":0},{"id":"dp5_4l1q4-a3","text":"False","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat5.4/l1q4.json
// module id = 1342
// module chunks = 41